export const ExpenseCategories = {
  WORKER: "WORKER_EXPENSE",
  VENDOR: "VENDOR_EXPENSE",
  SUBCONTRACTOR: "SUBCONTRACTOR_EXPENSE",
  EMPLOYEE: "EMPLOYEE_EXPENSE",
  OTHER: "Other Expense",
};
